import axios from 'axios'

export const getCategories = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/categories/getCategories')
    .then(response => {
      commit('getCategories', response.data.data)
    })
    .catch(e => {
      console.error('categories/getCategories:', e);
      commit('getCategories', []);
    })
    .finally(() => {
      commit('setLoading', false);
    });
}